// import Text from '../../assets/styles/Text';
import { useTheme } from 'styled-components';
import ads from '../../assets/images/ads-segurity.png';
import Center from '../../assets/styles/Center';
import DefaultContainer from '../../assets/styles/DefaultContainer';
import Ad from '../../components/Ad';
import Error from '../../components/Error';
import Loader from '../../components/Loader';
import { useClientById } from '../../hooks/queries/useClients';
import { useStore } from '../../stores';
import Banner from './components/Banner';
import CollumnLeft from './components/CollumnLeft';
import CollumnRight from './components/CollumnRight';
import * as styles from './styles';

export default function ClientDashboard() {
  const theme = useTheme();
  const user = useStore((state) => state.user);

  const {
    data: client,
    isLoading: isLoadingClient,
    isError,
    error,
  } = useClientById(user?.id);

  const isLoading = isLoadingClient;

  if (isLoading) return <Loader isLoading={isLoading} />;

  if (isError) {
    return <Error isError message={error.message} />;
  }

  return (
    <DefaultContainer $background={theme.colors.gradient[0]}>
      <Center className="center">
        <Banner client={client} />
        <styles.Container>
          <CollumnLeft />
          <CollumnRight />
        </styles.Container>

        <Ad img={ads} />
      </Center>
    </DefaultContainer>
  );
}
